import { useState } from "react";
import { ownerApi, formatDetail } from "../api";
import { useOwnerAuth } from "../OwnerAuthContext";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "@/lib/toastBanner";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const { owner, logout } = useOwnerAuth();
  const nav = useNavigate();
  const [curr, setCurr] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (next.length < 8) { setErr("New password must be at least 8 characters."); return; }
    if (next !== confirm) { setErr("New passwords do not match."); return; }
    if (next === curr) { setErr("New password must differ from the current one."); return; }
    setBusy(true);
    try {
      await ownerApi.post("/me/change-password", { current_password: curr, new_password: next });
      toast.success("Password changed. Please sign in again.");
      await logout();
      nav("/owner/login", { replace: true });
    } catch (e2) {
      setErr(formatDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-xl" data-testid="owner-profile">
      <h1 className="text-2xl font-heading font-bold text-[#f1fcff]">Your Profile</h1>
      <p className="text-sm text-[#ebeef5]/70 mt-1">Signed in as <span className="text-[#10b7c0]">{owner?.email}</span></p>

      <div className="mt-8 bg-[#0a1530] border border-white/10 rounded-xl p-6">
        <div className="flex items-center gap-2 mb-5">
          <KeyRound className="h-4 w-4 text-[#10b7c0]" />
          <h2 className="font-heading font-bold text-sm">Change password</h2>
        </div>
        <form onSubmit={submit} data-testid="owner-profile-form">
          <F label="Current password" type="password" value={curr} onChange={setCurr} testid="profile-current" />
          <F label="New password" type="password" value={next} onChange={setNext} testid="profile-new" />
          <F label="Confirm new password" type="password" value={confirm} onChange={setConfirm} testid="profile-confirm" />
          {err && <p className="text-xs text-red-400 mb-3" data-testid="owner-profile-error">{err}</p>}
          <button
            type="submit"
            disabled={busy}
            className="bg-[#10b7c0] hover:bg-[#0ea2aa] disabled:opacity-50 text-black text-xs font-semibold px-3 py-2 rounded-md flex items-center gap-1.5"
            data-testid="owner-profile-submit"
          >
            {busy && <Loader2 className="h-3 w-3 animate-spin" />} Change password & sign out
          </button>
        </form>
      </div>
    </div>
  );
}

function F({ label, type, value, onChange, testid }) {
  return (
    <div className="mb-3">
      <label className="block text-[10px] uppercase tracking-wider font-semibold text-[#ebeef5]/70 mb-1">{label}<span className="text-red-400"> *</span></label>
      <input
        type={type}
        required
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="w-full bg-[#040b1d] border border-white/10 rounded-lg px-3 py-2 text-sm text-[#f1fcff] focus:outline-none focus:border-[#10b7c0]/50"
      />
    </div>
  );
}
